// extracted by mini-css-extract-plugin
var _1 = "EmailReplyForm-moduleformBody__GDXry EmailCreationForm-moduleformBody__hZad9";
var _2 = "EmailReplyForm-moduleshowTrimmedContentButton__gHHeb";
var _3 = "EmailReplyForm-moduleshowTrimmedContentButtonHidden__Ojl5e";
export { _1 as "formBody", _2 as "showTrimmedContentButton", _3 as "showTrimmedContentButtonHidden" }
